import React from 'react';
import moment from 'moment';
import cn from 'classnames';
import CertificationBadge from 'components/CertificationBadge';
import ModalContainer from 'components/shared/modal/modal_container';
import ScrollableContainer from 'components/shared/scrollable';
import DateFormat from 'constants/date_format';
import { Modal, Button, ButtonGroup } from 'ui';

const BadgesModal = ({ certifications, closeModal, showCertificateModal }) => (
  <ModalContainer onEscape={closeModal}>
    <Modal shown className="LessonVersionModal-wrapper bg-gray-lightest">
      <Modal.Content className="d-f fd-c">
        <h1 className="LessonVersionModal-title pb-24 ff-ss fw-n">
          {t('certifications.badges_modal.all_certification_badges')}
        </h1>
        <ScrollableContainer
          className="PublishedVersionCollection-scrollable bg-white pr-0"
          maxHeight={null}
        >
          <ul>
            {certifications.map(certification => (
              <li
                key={certification.id}
                className={cn(
                  'PublishedVersionCollection-dataRow h-bc-gray-lightest',
                  { Expired: certification.expired },
                )}
              >
                <div
                  className="py-16 d-f ai-c px-32 jc-sb h-56 h-cr-p"
                  onClick={() =>
                    showCertificateModal(certification.path.pathProgressId)
                  }
                  onKeyPress={() => {}}
                >
                  <div className="BadgesModalCertificationTitleContainer d-f ai-c">
                    <div
                      className={cn('d-f mr-16', {
                        Expired: certification.expired,
                      })}
                    >
                      <CertificationBadge
                        width={26}
                        height={32}
                        iconName={certification.badge.iconName}
                        foregroundColor={certification.badge.foregroundColor}
                        backgroundColor={certification.badge.backgroundColor}
                        image={certification.badge.image}
                      />
                    </div>
                    <span className="BadgesModalCertificationTitle fz-16 ws-nw">
                      {certification.path.title}
                    </span>
                  </div>
                  <div className="BadgesModalCertificationCompletedDate">
                    <span className="fz-14 c-brand-gray-dark">
                      {certification.expired
                        ? `${t('certifications.certificate.expired_on')} ${
                            certification.expirationDate &&
                            moment(certification.expirationDate).format(
                              DateFormat.LONG,
                            )
                          }`
                        : t('certifications.status.active')}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </ScrollableContainer>
      </Modal.Content>
      <ButtonGroup alignEnd className="pb-16 pr-32 pt-8">
        <Button onClick={closeModal}>{t('common.close')}</Button>
      </ButtonGroup>
    </Modal>
  </ModalContainer>
);

export default BadgesModal;
